import { ModalProps, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { CustomModal } from 'components/molecules/PricingSimulator/Modals/ScenarioColumnEditModal';
import { MouseEventHandler, ReactNode } from 'react';
import { BaseButtonProps } from 'antd/lib/button/button';

type PopupProps = {
    open: boolean;
    onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onSubmitClick: () => void;
    loading: boolean;
    description: string | ReactNode;
    title: string;
    okText: ReactNode;
    cancelText?: ReactNode;
    closable?: boolean;
    maskClosable?: boolean;
    subTitle?: string;
    okButtonProps?: ModalProps['okButtonProps'];
    width?: number;
};
const ConfirmationModal = ({
    open,
    onCancel,
    loading,
    onSubmitClick,
    description,
    okText,
    okButtonProps,
    title,
    subTitle,
    cancelText,
    width = 400,
    closable,
    maskClosable,
}: PopupProps) => {
    return (
        <CustomModal
            maskClosable={maskClosable}
            width={width}
            cancelButtonProps={{ style: { borderRadius: 6 } }}
            onCancel={(e) => {
                if (loading) return;
                onCancel(e);
            }}
            onOk={() => {
                if (loading) return;
                onSubmitClick();
            }}
            title={title}
            centered
            closable={closable}
            open={open}
            cancelText={cancelText}
            okButtonProps={okButtonProps}
            okText={okText}
        >
            <p className="pl-2">{subTitle}</p>
            {description && (
                <div className="pl-2 mt-2 text-backgroundGreyAlt7 font-xs">
                    {typeof description === 'string' ? <p>{description}</p> : description}
                </div>
            )}
        </CustomModal>
    );
};
export default ConfirmationModal;
